import { Injectable } from '@angular/core';

@Injectable()
export class AppSettings {
  // public ApiBaseUrl = 'https://creativeallies-dev-api.aspcore.net';
  public ApiBaseUrl = 'https://creative-allies-api.azurewebsites.net';
  // public ApiBaseUrl = 'https://localhost:44356';
}



// WEBPACK FOOTER //
// ./src/helpers/app.settings.ts